export default "__VITE_ASSET__5ee4beb9__"